import { render } from "./IconItalic.vue?vue&type=template&id=c52eaae8"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconItalic.vue"]])

export default __exports__